import Parse from '@/parse'
import { format } from 'date-fns'

export default {
  initForm ({ state, getters, commit }) {
    commit('setName', state.eventClosed.get('name'))
    commit('setPlace', state.eventClosed.get('place'))
    const date = state.eventClosed.get('date')
    commit('setYear', format(date, 'YYYY'))
    commit('setMonth', format(date, 'M'))
    commit('setDay', format(date, 'D'))
    commit('setStartHour', getters.splitHour(state.eventClosed.get('start')))
    commit('setStartMinute', getters.splitMinute(state.eventClosed.get('start')))
    commit('setFinishHour', getters.splitHour(state.eventClosed.get('finish')))
    commit('setFinishMinute', getters.splitMinute(state.eventClosed.get('finish')))
    commit('setContent', state.eventClosed.get('content'))
  },

  retrieve ({ commit }) {
    var query = new Parse.Query('EventClosed')
    query.descending('createdAt')
    query.find().then((results) => {
      commit('setEventCloseds', results)
    }).catch((error) => {
      console.log(error)
    })
  },

  async get ({ commit }, id) {
    let query = new Parse.Query('EventClosed')
    try {
      let object = await query.get(id)
      commit('setEventClosed', object)
    } catch (error) {
      console.log(error)
    }
  }
}
